export enum ConnectionUsage {
  source = 'source',
  destination = 'destination',
}
